import { createContext } from 'react';
import type { PaletteMode } from '@mui/material';

export interface ThemeContextProps {
  mode: PaletteMode;
  toggleTheme: () => void;
}

const ThemeContext = createContext<ThemeContextProps>({
  mode: 'light',
  toggleTheme: () => {},
});

export { ThemeContext };
